import React, { useCallback } from "react";
import { FileWithPath, useDropzone } from "react-dropzone";
import { Button, Stack, SxProps, Typography } from "@mui/material";
import { FileUpload, InsertDriveFile } from "@mui/icons-material";

type DropzoneProps = {
  uploadTitle?: string;
  emptyTitle?: string;
  onChange?: (file: File) => void;
  sx?: SxProps;
};

export const Dropzone: React.FC<DropzoneProps> = (props) => {
  const {
    uploadTitle = "Upload file",
    emptyTitle = "No file selected",
    onChange,
    sx = {},
  } = props;

  const onDrop = useCallback((acceptedFiles: FileWithPath[]) => {
    onChange(acceptedFiles[0]);
  }, []);

  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    maxFiles: 1,
    onDrop,
  });

  return (
    <Stack direction="row" alignItems="center" spacing={2} sx={sx}>
      <Button
        {...getRootProps()}
        variant="outlined"
        size="small"
        color="primary"
        startIcon={<FileUpload />}
      >
        <input {...getInputProps()} />
        {uploadTitle}
      </Button>

      <Stack direction="row" spacing={1}>
        <InsertDriveFile
          fontSize="small"
          sx={{
            color: "primary.dark",
          }}
        />

        <Typography variant="subtitle2" color="primary.dark">
          {acceptedFiles.length ? acceptedFiles[0].name : emptyTitle}
        </Typography>
      </Stack>
    </Stack>
  );
};
